import MaterialUiCardActions from "@material-ui/core/CardActions";
import * as React from "react";

export const CardActions: React.FC = props => (
  <MaterialUiCardActions {...props} />
);
